import React, { useState } from 'react';
import unsplash from '../api/unsplash';
import {
    Checkbox,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Button,
    TextField,
    DialogActions,
    Grid,
    ButtonGroup,
    FormControlLabel,
    Zoom,
    IconButton,
    LinearProgress,
    Autocomplete,
    Chip,
    Stack,
    Tooltip,
    Typography,
} from '@mui/material';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { CustomFooterPersonalized } from '../utils/CustomFooterPersonalized';
import { Add, Group, Edit } from '@mui/icons-material';
import GlobalSnackbar from './Snackbar';
import EditIcon from '@mui/icons-material/Edit';
import { Delete, Close, Check } from '@mui/icons-material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const GestioneUtenti = (props) => {
    const [open, setOpen] = useState(false);
    const [utenti, setUtenti] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filtroUtenti, setFiltroUtenti] = useState('tutti');

    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    px: 2,
                    py: 1.5,
                    gap: 1.5,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    justifyContent: 'space-between',
                }}
            >
                <GridToolbarQuickFilter
                    placeholder="Cerca username o email..."
                    sx={{ minWidth: { xs: 220, sm: 320 } }}
                />
                <ButtonGroup
                    size="small"
                    aria-label="Filtra gli utenti"
                    sx={{ flexWrap: 'wrap' }}
                >
                    <Button
                        variant={
                            filtroUtenti === 'tutti'
                                ? 'contained'
                                : 'outlined'
                        }
                        onClick={() => setFiltroUtenti('tutti')}
                    >
                        Tutti
                    </Button>
                    <Button
                        variant={
                            filtroUtenti === 'admin'
                                ? 'contained'
                                : 'outlined'
                        }
                        onClick={() => setFiltroUtenti('admin')}
                    >
                        Admin
                    </Button>
                    <Button
                        variant={
                            filtroUtenti === 'limitati'
                                ? 'contained'
                                : 'outlined'
                        }
                        onClick={() => setFiltroUtenti('limitati')}
                    >
                        Accesso limitato
                    </Button>
                </ButtonGroup>
            </GridToolbarContainer>
        );
    }

    const columns = [
        {
            filterable: false,

            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            width: 96,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => {
                const isCurrentUser =
                    String(params.row.username || '').trim().toLowerCase() ===
                    String(sessionStorage.getItem('username') || '')
                        .trim()
                        .toLowerCase();

                return (
                    <Stack direction="row" spacing={0}>
                        <Tooltip title={`Modifica ${params.row.username}`}>
                            <span>
                                <ModificaUtente
                                    utente={params.row}
                                    handleLoadUtenti={handleLoadUtenti}
                                    snack={snack}
                                    openSnack={openSnack}
                                    handleCloseSnack={handleCloseSnack}
                                    setSnack={setSnack}
                                    setOpenSnack={setOpenSnack}
                                />
                            </span>
                        </Tooltip>
                        {isCurrentUser ? (
                            <Tooltip title="Non puoi eliminare l’utenza con cui hai effettuato l’accesso">
                                <span>
                                    <IconButton
                                        disabled
                                        aria-label="Eliminazione non consentita"
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        ) : (
                            <Tooltip title={`Elimina ${params.row.username}`}>
                                <span>
                                    <DeleteDialog
                                        categoria={params.row}
                                        myFunction={handleDelete}
                                        snack={snack}
                                        openSnack={openSnack}
                                        handleCloseSnack={handleCloseSnack}
                                        setSnack={setSnack}
                                        setOpenSnack={setOpenSnack}
                                    />
                                </span>
                            </Tooltip>
                        )}
                    </Stack>
                );
            },
        },
        {
            field: 'username',
            headerName: 'Username',
            //width: 400,
            flex: 1,
            minWidth: 180,
            headerAlign: 'left',
            align: 'left',
        },
        {
            field: 'tipoUtente',
            headerName: 'Ambiti',
            flex: 1.35,
            minWidth: 310,
            headerAlign: 'left',
            align: 'left',
            sortable: false,
            renderCell: (params) => {
                const ambiti = [
                    params.row.Sicurezza ? 'Sicurezza' : null,
                    params.row.Formazione ? 'Formazione' : null,
                    params.row.Medicina ? 'Medicina' : null,
                ].filter(Boolean);

                return ambiti.length ? (
                    <Tooltip title={ambiti.join(', ')}>
                        <Typography
                            variant="body2"
                            noWrap
                            sx={{ fontWeight: 500, color: 'text.primary' }}
                        >
                            {ambiti.join(' · ')}
                        </Typography>
                    </Tooltip>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        Nessun ambito
                    </Typography>
                );
            },
        },
        {
            field: 'email',
            headerName: 'Email',
            //width: 400,
            flex: 1.5,
            minWidth: 290,
            headerAlign: 'left',
            align: 'left',
            renderCell: (params) => (
                <Tooltip title={params.value || ''}>
                    <Typography variant="body2" noWrap>
                        {params.value || '—'}
                    </Typography>
                </Tooltip>
            ),
        },
        {
            field: 'Admin',
            headerName: 'Ruolo',
            width: 150,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Chip
                    label={
                        Number(params.value) === 1
                            ? 'Amministratore'
                            : 'Standard'
                    }
                    size="small"
                    color={Number(params.value) === 1 ? 'primary' : 'default'}
                    sx={{
                        fontWeight: 600,
                        ...(Number(params.value) !== 1 && {
                            bgcolor: 'grey.200',
                            color: 'grey.800',
                        }),
                    }}
                />
            ),
        },
        {
            field: 'VisibilitaLimitata',
            headerName: 'Visibilità',
            width: 135,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Chip
                    label={
                        Number(params.value) === 1 ? 'Limitata' : 'Completa'
                    }
                    size="small"
                    color={
                        Number(params.value) === 1 ? 'warning' : 'success'
                    }
                    variant="outlined"
                    sx={{ fontWeight: 600, bgcolor: 'background.paper' }}
                />
            ),
        },
    ];

    const utentiFiltrati = utenti.filter((utente) => {
        if (filtroUtenti === 'admin') {
            return Number(utente.Admin) === 1;
        }
        if (filtroUtenti === 'limitati') {
            return Number(utente.VisibilitaLimitata) === 1;
        }
        return true;
    });

    const numeroAdmin = utenti.filter(
        (utente) => Number(utente.Admin) === 1
    ).length;

    const handleClickOpen = async () => {
        let response = await unsplash.get('utenti', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        setUtenti(response.data.data);
        setLoading(false);

        setOpen(true);
    };

    const handleLoadUtenti = async () => {
        let response = await unsplash.get('utenti', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        setUtenti(response.data.data);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = async (utente) => {
        let u = { ...utente };
        u.Attivo = 0;
        try {
            await unsplash.put(
                'utenti',
                { utente: u, operazione: 'elimina' },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            handleLoadUtenti();
            setSnack({
                severity: 'success',
                messaggio: 'Utente eliminato con successo',
            });
            setOpenSnack(true);
        } catch {
            setSnack({
                severity: 'error',
                messaggio: "Errore durante l'eliminazione",
            });
            setOpenSnack(true);
        }
    };

    //p[index].IDAggiuntivo = null;

    return (
        <>
            <Button
                startIcon={<Group />}
                className="ButtonMiller"
                fullWidth
                variant="contained"
                onClick={handleClickOpen}
            >
                Gestione Utenti
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        height: { xs: '100%', md: '88vh' },
                        maxHeight: { xs: '100%', md: 900 },
                        overflow: 'hidden',
                    },
                }}
            >
                <GlobalSnackbar
                    severity={snack.severity}
                    messaggio={snack.messaggio}
                    openSnack={openSnack}
                    handleCloseSnack={handleCloseSnack}
                />
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2,
                        pb: 1.5,
                    }}
                >
                    <Box>
                        <Typography variant="h5" component="h2">
                            Gestione Utenti
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {utenti.length} utenti attivi · {numeroAdmin}{' '}
                            amministratori
                        </Typography>
                    </Box>
                    <CreaUtente handleLoadUtenti={handleLoadUtenti} />
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        pb: 1,
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            minHeight: 420,
                            width: 1,
                        }}
                    >
                        <DataGridPro
                            initialState={{
                                sorting: {
                                    sortModel: [
                                        { field: 'username', sort: 'asc' },
                                    ],
                                },
                            }}
                            sx={{
                                fontSize: 13,
                                borderColor: 'divider',
                                '& .MuiDataGrid-columnHeaders': {
                                    bgcolor: 'primary.main',
                                    color: 'primary.contrastText',
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 600,
                                },
                                '& .MuiDataGrid-row:hover': {
                                    bgcolor: 'action.hover',
                                },
                                '& .MuiDataGrid-cell': {
                                    borderColor: 'divider',
                                },
                                '& .MuiDataGrid-virtualScroller': {
                                    overflowX: {
                                        xs: 'auto',
                                        md: 'hidden',
                                    },
                                },
                                '& .MuiDataGrid-cell[data-field="Actions"] .MuiIconButton-root':
                                    {
                                        p: 0.75,
                                    },
                                '& .MuiDataGrid-cell[data-field="Actions"] svg':
                                    {
                                        width: '1.55rem !important',
                                        height: '1.55rem !important',
                                    },
                            }}
                            components={{
                                Toolbar: CustomToolbar,
                                Footer: CustomFooterPersonalized,
                            }}
                            slots={{
                                loadingOverlay: LinearProgress,
                            }}
                            loading={loading}
                            localeText={
                                itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                            }
                            rows={utentiFiltrati}
                            columns={columns}
                            getRowId={(row) => row.ID}
                            pageSize={100}
                            rowHeight={56}
                            columnHeaderHeight={52}
                            disableSelectionOnClick
                        />
                    </Box>
                </DialogContent>
                <DialogActions
                    sx={{
                        px: 3,
                        py: 1.5,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        startIcon={<Close />}
                    >
                        Chiudi
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
export default GestioneUtenti;

const CreaUtente = (props) => {
    const [open, setOpen] = useState(false);
    const [utente, setUtente] = useState();
    const [clienti, setClienti] = useState([]);
    const [clientiSelezionati, setClientiSelezionati] = useState([]);
    const [loadingClienti, setLoadingClienti] = useState(false);
    const [checkingAvailability, setCheckingAvailability] = useState(false);
    const [availabilityErrors, setAvailabilityErrors] = useState({
        username: false,
        email: false,
    });
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });

    const handleChange = (e) => {
        let u = { ...utente };
        u[e.target.name] = e.target.value;
        setUtente(u);
        if (e.target.name === 'username' || e.target.name === 'email') {
            setAvailabilityErrors((errors) => ({
                ...errors,
                [e.target.name]: false,
            }));
        }
    };

    const checkAvailability = async () => {
        if (!utente?.username?.trim() && !utente?.email?.trim()) {
            return true;
        }

        setCheckingAvailability(true);
        try {
            const response = await unsplash.get('utenti/availability', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: {
                    username: utente?.username?.trim(),
                    email: utente?.email?.trim(),
                },
            });
            const conflicts = response.data.conflicts || {};
            setAvailabilityErrors({
                username: Boolean(conflicts.username),
                email: Boolean(conflicts.email),
            });
            return response.data.available;
        } catch {
            // Il controllo definitivo viene comunque ripetuto dal backend
            // durante il salvataggio.
            return true;
        } finally {
            setCheckingAvailability(false);
        }
    };

    const handleClickOpen = async () => {
        setUtente({
            username: '',
            //tipoUtente: "Sicurezza",
            Admin: 0,
            email: '',
            Medicina: 0,
            Formazione: 0,
            Sicurezza: 0,
            VisibilitaLimitata: 0,
        });
        setClientiSelezionati([]);
        setAvailabilityErrors({ username: false, email: false });
        setOpen(true);

        setLoadingClienti(true);
        try {
            const response = await unsplash.get('clienti', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { all: 'yes' },
            });
            setClienti(response.data.data);
        } catch {
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante il caricamento delle aziende',
            });
            setOpenSnack(true);
        } finally {
            setLoadingClienti(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    //p[index].IDAggiuntivo = null;

    const handleSave = async () => {
        const available = await checkAvailability();
        if (!available) {
            setSnack({
                severity: 'error',
                messaggio: 'Correggi i dati già utilizzati prima di salvare',
            });
            setOpenSnack(true);
            return;
        }

        try {
            const response = await unsplash.post(
                'utenti',
                { utente: utente },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            const idUtenteCreato = response.data?.message?.insertId;
            if (
                utente.VisibilitaLimitata === 1 &&
                clientiSelezionati.length > 0
            ) {
                if (!idUtenteCreato) {
                    throw new Error(
                        "Identificativo del nuovo utente non disponibile"
                    );
                }

                await Promise.all(
                    clientiSelezionati.map((cliente) =>
                        unsplash.post(
                            'relUtentiClienti',
                            {
                                utentiClienti: {
                                    IDutente: idUtenteCreato,
                                    IDCliente: cliente.ID,
                                },
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem(
                                        'jwt'
                                    )}`,
                                },
                            }
                        )
                    )
                );
            }

            setOpen(false);
            props.handleLoadUtenti();
            setSnack({
                severity: 'success',
                messaggio: 'Utente creato con successo',
            });
            setOpenSnack(true);
        } catch (error) {
            if (error.response?.status === 409) {
                const conflicts = error.response.data?.conflicts || {};
                setAvailabilityErrors({
                    username: Boolean(conflicts.username),
                    email: Boolean(conflicts.email),
                });
                setSnack({
                    severity: 'error',
                    messaggio:
                        conflicts.username && conflicts.email
                            ? 'Username ed email sono già utilizzati'
                            : conflicts.username
                            ? 'Username già utilizzato'
                            : 'Email già utilizzata',
                });
                setOpenSnack(true);
                return;
            }
            setSnack({
                severity: 'error',
                messaggio: 'Errore durante la creazione',
            });
            setOpenSnack(true);
        }
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Button
                startIcon={<Add />}
                className="ButtonMiller"
                variant="contained"
                onClick={handleClickOpen}
            >
                Aggiungi
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        overflow: 'hidden',
                    },
                }}
            >
                <DialogTitle sx={{ pb: 1 }}>
                    <Typography variant="h5" component="h2">
                        Aggiungi utente
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Crea un nuovo accesso a Koala e assegna i permessi
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{ pt: '18px !important' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                name="username"
                                label="Username"
                                type="text"
                                fullWidth
                                value={utente?.username}
                                onChange={handleChange}
                                onBlur={checkAvailability}
                                variant="outlined"
                                required
                                autoFocus
                                error={availabilityErrors.username}
                                helperText={
                                    availabilityErrors.username
                                        ? 'Username già utilizzato'
                                        : ' '
                                }
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                name="email"
                                label="Email"
                                type="email"
                                fullWidth
                                value={utente?.email}
                                onChange={handleChange}
                                onBlur={checkAvailability}
                                variant="outlined"
                                required
                                error={availabilityErrors.email}
                                helperText={
                                    availabilityErrors.email
                                        ? 'Email già utilizzata'
                                        : ' '
                                }
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    p: 1.5,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    sx={{ mb: 0.5 }}
                                >
                                    Permessi
                                </Typography>
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={{ xs: 0, sm: 3 }}
                                    flexWrap="wrap"
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    utente?.Sicurezza === 1
                                                }
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.Sicurezza = e.target
                                                        .checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Sicurezza"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    utente?.Formazione === 1
                                                }
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.Formazione = e.target
                                                        .checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Formazione"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={utente?.Admin === 1}
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.Admin = e.target.checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Amministratore"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    utente?.VisibilitaLimitata ===
                                                    1
                                                }
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.VisibilitaLimitata = e
                                                        .target.checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Limita la visibilità alle aziende selezionate"
                                    />
                                </Stack>
                                {utente?.VisibilitaLimitata === 1 && (
                                    <Box sx={{ mt: 1.5 }}>
                                        <Autocomplete
                                            multiple
                                            disableCloseOnSelect
                                            options={clienti}
                                            value={clientiSelezionati}
                                            loading={loadingClienti}
                                            isOptionEqualToValue={(
                                                option,
                                                value
                                            ) => option.ID === value.ID}
                                            getOptionLabel={(option) =>
                                                option.RagioneSociale || ''
                                            }
                                            onChange={(event, newValue) =>
                                                setClientiSelezionati(newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Aziende visibili"
                                                    placeholder={
                                                        clientiSelezionati.length
                                                            ? ''
                                                            : 'Cerca e seleziona una o più aziende'
                                                    }
                                                    required
                                                    helperText="L'utente vedrà esclusivamente le aziende selezionate."
                                                />
                                            )}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                        py: 1.5,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        startIcon={<Close />}
                    >
                        Chiudi
                    </Button>
                    <Button
                        onClick={handleSave}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Check />}
                        disabled={
                            !utente?.username?.trim() ||
                            !utente?.email?.trim() ||
                            checkingAvailability ||
                            availabilityErrors.username ||
                            availabilityErrors.email ||
                            (utente?.VisibilitaLimitata === 1 &&
                                clientiSelezionati.length === 0)
                        }
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const ModificaUtente = (props) => {
    const [open, setOpen] = useState(false);
    const [visibilityTable, setVisibilityTable] = useState(false);
    const [utente, setUtente] = useState();
    const [relClienti, setRelClienti] = useState([]);
    const [clienti, setClienti] = useState([]);
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const [loading, setLoading] = useState(true);

    function CustomToolbar() {
        return (
            <GridToolbarContainer
                sx={{
                    px: 1.5,
                    py: 1,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                }}
            >
                <GridToolbarQuickFilter
                    placeholder="Cerca azienda..."
                    sx={{ minWidth: 280 }}
                />
            </GridToolbarContainer>
        );
    }

    const columns = [
        {
            filterable: false,

            field: 'Actions',
            headerName: 'Azioni',
            hide: false,
            width: 105,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <>
                    <ModalRelUtenteCliente
                        clienti={clienti}
                        operazione="editRel"
                        utenteCliente={params.row}
                        relClienti={relClienti}
                        handleLoadUtenti={handleLoadUtentiClienti}
                        saveFunction={handleSaveRel}
                    />
                    {/* <IconButton
            aria-label="edit"
            onClick={async () => {
              await setUtenteSel(params.row);
              console.log(params.row);
              document.getElementById("editRel").click();
            }}
          >
            <EditIcon
              style={{ height: "2rem", width: "2rem", color: "#2265B1" }}
            />
          </IconButton> */}
                    <DeleteDialogRel
                        utenteCliente={params.row}
                        handleLoad={handleLoadUtentiClienti}
                        snack={snack}
                        openSnack={openSnack}
                        handleCloseSnack={handleCloseSnack}
                        setSnack={setSnack}
                        setOpenSnack={setOpenSnack}
                    />
                </>
            ),
        },
        {
            field: 'RagioneSociale',
            headerName: 'Azienda',
            flex: 1,
            minWidth: 320,
            headerAlign: 'left',
            align: 'left',
        },
    ];

    const handleChange = (e) => {
        let u = { ...utente };
        u[e.target.name] = e.target.value;
        setUtente(u);
    };

    const handleLoadUtentiClienti = async (eliminazione) => {
        if (eliminazione) {
            setSnack({
                severity: eliminazione,
                messaggio:
                    eliminazione === 'success'
                        ? 'Azienda eliminata con successo'
                        : "Errore durante l'eliminazione",
            });
            setOpenSnack(true);
        }
        let response = await unsplash.get('relUtentiClienti', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
            params: {
                id: props.utente.ID,
            },
        });
        setRelClienti(response.data.data);
    };

    const handleClickOpen = async () => {
        setUtente(props.utente);
        try {
            let response = await unsplash.get('clienti', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { all: 'yes' },
            });
            setClienti(response.data.data);
        } catch (error) {
            console.error(error.message);
        }
        if (props.utente?.VisibilitaLimitata) {
            setVisibilityTable(true);
            await handleLoadUtentiClienti();
            setLoading(false);
        }

        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setVisibilityTable(false);
    };

    const handleVisibilityChange = async (checked) => {
        setUtente((utenteCorrente) => ({
            ...utenteCorrente,
            VisibilitaLimitata: checked ? 1 : 0,
        }));
        setVisibilityTable(checked);

        if (checked) {
            setLoading(true);
            await handleLoadUtentiClienti();
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            let u = { ...utente };
            u.Attivo = 1;
            await unsplash.put(
                'utenti',
                { utente: u },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                    },
                }
            );

            setOpen(false);
            setVisibilityTable(false);
            props.handleLoadUtenti();
            props.setSnack({
                severity: 'success',
                messaggio: 'Utente modificato con successo',
            });
            props.setOpenSnack(true);
        } catch {
            props.setSnack({
                severity: 'error',
                messaggio: 'Errore durante la modifica',
            });
            props.setOpenSnack(true);
        }
    };

    const handleSaveRel = async (utenteCliente, operazione) => {
        if (operazione === 'new') {
            try {
                await unsplash.post(
                    'relUtentiClienti',
                    { utentiClienti: utenteCliente },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );
                handleLoadUtentiClienti();
                setSnack({
                    severity: 'success',
                    messaggio: 'Azienda aggiunta con successo',
                });
                setOpenSnack(true);
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: 'Errore durante la creazione',
                });
                setOpenSnack(true);
            }
        } else {
            try {
                await unsplash.put(
                    'relUtentiClienti',
                    { utentiClienti: utenteCliente },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );

                //setOpen(false);
                handleLoadUtentiClienti();
                setSnack({
                    severity: 'success',
                    messaggio: 'Azienda aggiornata con successo',
                });
                setOpenSnack(true);
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: 'Errore durante la creazione',
                });
                setOpenSnack(true);
            }
        }
    };

    return (
        <>
            <IconButton
                aria-label="edit"
                onClick={() => handleClickOpen()}
                id="editUser"
            >
                <EditIcon
                    style={{ height: '2rem', width: '2rem', color: '#2265B1' }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="lg"
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        height: { xs: '100%', md: '88vh' },
                        maxHeight: { xs: '100%', md: 900 },
                        overflow: 'hidden',
                    },
                }}
            >
                <GlobalSnackbar
                    severity={snack.severity}
                    messaggio={snack.messaggio}
                    openSnack={openSnack}
                    handleCloseSnack={handleCloseSnack}
                />
                <DialogTitle sx={{ pb: 1 }}>
                    <Typography variant="h5" component="h2">
                        Modifica utente
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        Aggiorna i dati, i permessi e le aziende visibili
                    </Typography>
                </DialogTitle>
                <DialogContent
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        overflow: 'hidden',
                        pt: '18px !important',
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                name="username"
                                label="Username"
                                type="text"
                                fullWidth
                                value={utente?.username}
                                onChange={handleChange}
                                variant="outlined"
                                disabled
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                name="email"
                                label="Email"
                                type="email"
                                fullWidth
                                value={utente?.email}
                                onChange={handleChange}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >
                            <Box
                                sx={{
                                    p: 1.5,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    sx={{ mb: 0.5 }}
                                >
                                    Permessi
                                </Typography>
                                <Stack
                                    direction={{ xs: 'column', sm: 'row' }}
                                    spacing={{ xs: 0, sm: 3 }}
                                    flexWrap="wrap"
                                >
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    utente?.Sicurezza === 1
                                                }
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.Sicurezza = e.target
                                                        .checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Sicurezza"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    utente?.Formazione === 1
                                                }
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.Formazione = e.target
                                                        .checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Formazione"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={utente?.Admin === 1}
                                                onChange={(e) => {
                                                    let u = { ...utente };
                                                    u.Admin = e.target.checked
                                                        ? 1
                                                        : 0;
                                                    setUtente(u);
                                                }}
                                            />
                                        }
                                        label="Amministratore"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={
                                                    utente?.VisibilitaLimitata ===
                                                    1
                                                }
                                                onChange={(e) =>
                                                    handleVisibilityChange(
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                        }
                                        label="Limita la visibilità alle aziende selezionate"
                                    />
                                </Stack>
                            </Box>
                        </Grid>
                    </Grid>
                    {visibilityTable ? (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 1,
                                minHeight: 300,
                                overflow: 'hidden',
                            }}
                        >
                            <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                                sx={{ mb: 1 }}
                            >
                                <Box>
                                    <Typography variant="subtitle1">
                                        Aziende visibili
                                    </Typography>
                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                    >
                                        {relClienti.length} aziende associate
                                    </Typography>
                                </Box>
                                <ButtonGroup>
                                    <ModalRelUtenteCliente
                                        operazione={'new'}
                                        idUtente={utente.ID}
                                        relClienti={relClienti}
                                        clienti={clienti}
                                        handleLoadUtenti={
                                            handleLoadUtentiClienti
                                        }
                                        saveFunction={handleSaveRel}
                                    />
                                </ButtonGroup>
                            </Stack>
                            <Box sx={{ flex: 1, minHeight: 0 }}>
                                <DataGridPro
                                    initialState={{
                                        sorting: {
                                            sortModel: [
                                                {
                                                    field: 'RagioneSociale',
                                                    sort: 'asc',
                                                },
                                            ],
                                        },
                                    }}
                                    sx={{
                                        fontSize: 13,
                                        '& .MuiDataGrid-columnHeaders': {
                                            bgcolor: 'primary.main',
                                            color: 'primary.contrastText',
                                        },
                                        '& .MuiDataGrid-columnHeaderTitle': {
                                            fontWeight: 600,
                                        },
                                        '& .MuiDataGrid-virtualScroller': {
                                            overflowX: 'hidden',
                                        },
                                    }}
                                    components={{
                                        Toolbar: CustomToolbar,
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                    }}
                                    loading={loading}
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    rows={relClienti}
                                    columns={columns}
                                    getRowId={(row) => row.ID}
                                    pageSize={100}
                                    rowHeight={52}
                                    columnHeaderHeight={48}
                                    disableSelectionOnClick
                                />
                            </Box>
                        </Box>
                    ) : (
                        <Box
                            sx={{
                                p: 2,
                                bgcolor: 'action.hover',
                                borderRadius: 1,
                            }}
                        >
                            <Typography variant="body2">
                                L'utente può vedere tutte le aziende.
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                        py: 1.5,
                        borderTop: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        startIcon={<Close />}
                    >
                        Chiudi
                    </Button>

                    <Button
                        onClick={handleSave}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Check />}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DeleteDialog = (props) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <IconButton aria-label="edit" onClick={handleClickOpen}>
                <Delete
                    style={{ height: '2rem', width: '2rem', color: '#FF2768' }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ mx: 'auto' }}>
                    Sei sicuro di voler eliminare l'utente selezionata?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare il seguente
                        utente:
                        <br />
                        <b>{props.categoria.username}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button onClick={() => props.myFunction(props.categoria)}>
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
const ModalRelUtenteCliente = (props) => {
    const [openRel, setOpenRel] = useState(false);
    const [utenteCliente, setUtenteCliente] = useState({});

    const [clienti, setClienti] = useState([]);

    const [clientiSel, setClientiSel] = useState(null);

    const handleClickOpen = () => {
        const client = props.clienti.filter((el) => {
            return props.relClienti?.every((rel) => rel.IDCliente !== el.ID);
        });
        setClienti(client);
        console.log(props);
        if (props.operazione !== 'new') {
            setUtenteCliente({
                IDutente: props.utenteCliente?.IDutente,
                IDCliente: props.utenteCliente?.IDCliente,
            });
            setClientiSel(
                props.clienti?.filter(
                    (c) => c.ID === props.utenteCliente?.IDCliente
                )[0]
            );
        } else {
            //filtro clienti già associati
            setUtenteCliente({
                IDutente: props.idUtente,
                IDCliente: null,
            });
            setClientiSel(null);
        }
        setOpenRel(true);
        console.log(openRel);
    };

    const handleClose = () => {
        setOpenRel(false);
    };

    const handleSave = async () => {
        props.saveFunction(utenteCliente, props.operazione);
        setOpenRel(false);
    };

    return (
        <>
            <IconButton
                style={{
                    display: props.operazione !== 'editRel' ? 'None' : '',
                }}
                aria-label="editRel"
                onClick={handleClickOpen}
                id={props.operazione}
            >
                <Edit
                    style={{ height: '2rem', width: '2rem', color: '#2265B1' }}
                />
            </IconButton>
            <ButtonGroup
                variant="contained"
                aria-label="outlined primary button group"
            >
                <Button
                    startIcon={<Add />}
                    onClick={handleClickOpen}
                    id={props.operazione}
                    sx={{
                        color: 'white',
                        display: props.operazione === 'editRel' ? 'None' : '',
                    }}
                    variant="outlined"
                    className="ButtonMiller"
                >
                    Aggiungi
                </Button>
            </ButtonGroup>
            <Dialog
                open={openRel}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                TransitionComponent={Transition}
            >
                <DialogTitle>
                    {props.operazione === 'new' ? 'Aggiungi' : 'Modifica'}{' '}
                    Azienda
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} marginTop={1}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={clienti}
                                fullWidth
                                value={clientiSel}
                                getOptionLabel={(option) =>
                                    option.RagioneSociale
                                }
                                onChange={(event, newValue) => {
                                    setClientiSel(newValue);
                                    let a = { ...utenteCliente };
                                    a.IDCliente = newValue ? newValue.ID : null;
                                    setUtenteCliente(a);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Aziende" />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mx: 2,
                    }}
                >
                    <Button
                        onClick={handleClose}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Close />}
                    >
                        Chiudi
                    </Button>
                    <Button
                        onClick={handleSave}
                        className="ButtonMiller"
                        variant="contained"
                        startIcon={<Check />}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
const DeleteDialogRel = (props) => {
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleDeleteRel = async (utenteCliente) => {
        try {
            await unsplash.delete('relUtentiClienti', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                data: {
                    id: utenteCliente.ID,
                },
            });
            props.handleLoad('success');
        } catch {
            props.handleLoad('error');
        }
        handleClose();
    };

    return (
        <>
            <IconButton aria-label="edit" onClick={handleClickOpen}>
                <Delete
                    style={{ height: '2rem', width: '2rem', color: '#FF2768' }}
                />
            </IconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ mx: 'auto' }}>
                    Sei sicuro di voler eliminare l'azienda selezionato?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare la seguente
                        azienda:
                        <br />
                        <b>{props.utenteCliente?.RagioneSociale}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        px: 3,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button
                        onClick={() => handleDeleteRel(props.utenteCliente)}
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
